import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const NotificationsFullPageComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "NotificationsFullPage" */ "@circle-react/components/NotificationsFullPage"
    ),
);

export const NotificationsFullPage = () => (
  <Suspense fallback={<PageLoader />}>
    <NotificationsFullPageComponent />
  </Suspense>
);
